<script>

import { Overlay } from '../../'

export default {
    name: 'DEMA',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad', version: '1.0.0',
                desc: 'Double Exponential Moving Average - Reduces lag more than EMA',
                preset: {
                    name: 'DEMA $length',
                    side: 'onchart',
                    settings: {
                        lineWidth: 0.75,
                        color: '#ff9800'
                    }
                }
            }
        },
        use_for() { return ['DEMA'] },
        calc() {
            return {
                props: {
                    length: { def: 21, text: 'Length' }
                },
                conf: { renderer: 'Spline' },
                update: `
                    let first = ema(close, length)
                    let second = ema(first, length)
                    return 2 * first[0] - second[0]
                `
            }
        }
    }
}
</script>
